<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <el-form id="elForm" :model="queryForm" ref="queryForm" :inline="true"  class="demo-form-inline" label-width="85px" size="medium">

                      <el-form-item label="市：" prop="cityID" v-show="show.selCity" >
                        <el-select v-model="queryForm.cityID" placeholder="请选择市" @change="selectChange(1,queryForm.cityID)" @clear="clearSel('1')" clearable>
                          <el-option v-for="item in selectcity" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="区县：" prop="countryID" v-show="show.selCountry" >
                        <el-select v-model="queryForm.countryID" placeholder="请选择区" @change="selectChange(2,queryForm.countryID)" @clear="clearSel" clearable>
                          <el-option v-for="item in selectarea" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <!-- <el-form-item label="机构名称：" prop="orgID">
                          <el-select v-model="queryForm.orgID" placeholder="请选择幼机构名称" filterable>
                              <el-option v-for="item in selectGarden" :key="item.orgID" :label="item.fullName" :value="item.orgID"></el-option>
                          </el-select>
                      </el-form-item> -->
                      
                        <el-form-item label="机构名称：">
                           <!-- <el-select
                          v-model="queryForm.fullName"
                          multiple
                          filterable
                          remote
                          reserve-keyword
                          placeholder="请输入机构名称"
                          :remote-method="remoteMethod"
                          :loading="loading">
                          <el-option
                            v-for="item in options4"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select> -->
                          <el-select v-model="queryForm.fullName" filterable placeholder="请选择机构名称" clearable>
                            <el-option
                              v-for="item in selOrgList"
                              :key="item.orgID"
                              :label="item.fullName"
                              :value="item.fullName">
                            </el-option>
                          </el-select>

                            <!-- <el-input v-model="queryForm.fullName"></el-input> -->
                        </el-form-item>
                        <el-form-item label="联系人：">
                            <el-input v-model="queryForm.userName"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码：">
                            <el-input v-model="queryForm.loginTel"></el-input>
                        </el-form-item>
                        <el-form-item label="机构类型：">
                            <el-select v-model="queryForm.orgFirstType" @change="changeType()" id="institutionalType">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="公办" value="1"></el-option>
                                <el-option label="民办" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="机构级别：" ref="orgSecondType" v-show="orgSecondType">
                                  <el-select v-model="queryForm.orgSecondType">
                                  <el-option v-for="item in org" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button class="btn-primary" @click="getUsers">查询</el-button>
                            <el-button v-if="isDownloadTestPaper" class="btn-warning btn-outline" @click="downloadTestPaper()" size="small" plain><i class="el-icon-document"></i>试卷下载</el-button>
                        </el-form-item>
                    </el-form>
                    <!-- 用户列表-->
                    <div style='margin-bottom:15px' v-if='generalArea.length == 0'>
                       
                    </div>
                    <template>
                        <el-table :data="tableData" role="grid" class="table-bordered"  style="width: 100%">
                            <el-table-column type="selection" current-row-key="orgID"></el-table-column>
                            <el-table-column prop="fullName" label="机构名称"  show-overflow-tooltip></el-table-column>
                            <el-table-column prop="orgFirstTypeStr" label="机构类型"  show-overflow-tooltip></el-table-column>
                            <el-table-column prop="orgSecondTypeStr" label="机构级别"  show-overflow-tooltip></el-table-column>
                            <el-table-column prop="userName" label="联系人"></el-table-column>
                            <el-table-column prop="loginTel" label="手机号码" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="street" label="地址"  show-overflow-tooltip></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <!-- <el-button class="btn-warning btn-outline" @click="orgDel(scope.$index,scope.row)" size="small" plain><i class="el-icon-document"></i>详情</el-button> -->
                                    <el-button v-for='(item,index) in listArea' :key='index' class="btn-outline" @click="doClick(item.operFunc,scope.$index,scope.row)" size="small" plain>{{item.operName}}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                    <!--分页-->
                    <el-pagination :current-page="queryForm.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryForm.pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total_rows"
                        @size-change="pageSizeChange"  @current-change="pageCurrentChange" style="margin-top: 10px;">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!--彈出的添加-->
        <el-dialog  :visible.sync="dialogTableVisible" :close-on-click-modal='false'>
            <router-view v-on:close="close"></router-view>
        </el-dialog>
    </div>
</template>
<script>

import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import common from '../../com/common'
export default {

  name: 'app',
  data () {
    return {
            // 对象属性
      queryForm: {
        // orgID:'',
        cityID:'',
        countryID:'',
        fullName: '',
        loginTel: '',
        orgFirstType: '',
        orgSecondType: '',
        userName: '',
        pageNum: 1,
        pageSize: 10
      },
      isDownloadTestPaper:false,
      isGuizhou: false,
      show: {
        selCountry: false,
        selCity: false
      },
      selOrgList:[],
      tableData: [],
      selectcity: [], // 筛选条件下拉框市数据
      selectarea: [], // 筛选条件下拉框区数据
      // selectGarden:[],
      currentPage: 1,
      total_rows: 0,
      orgSecondType: false,
      dialogTableVisible: false,
      org: [],
      orgS: [// 公办集团
                { id: '', name: '全部' },
                { id: '11', name: '示范园' },
                { id: '12', name: '一级园' },
                { id: '13', name: '二级园' },
                { id: '14', name: '其他' }
      ],
      orgSguizhou: [// 公办集团-贵州
                { id: '', name: '全部' },
                { id: '21', name: '省级示范园' },
                { id: '32', name: '市级示范园' },
                { id: '33', name: '县级示范园' },
                { id: '34', name: '未评定' }
      ],
      orgSe: [// 民办集团
                { id: '', name: '全部' },
                { id: '21', name: '民办' },
                { id: '22', name: '民办集团' },
                { id: '23', name: '其他' }
      ],
      generalArea: [],
      listArea: []
    }
  },
  methods: {
    clearSel(type){

      this.selOrgList=[]
      this.queryForm.fullName=''

      if(type=="1"){
        this.selectarea=[]
        this.queryForm.countryID=''

        
      }
    },
    getOrg(){
      let self=this
      var param=self.queryForm
      delete param.pageNum
      delete param.pageSize

      api.post(config.host + 'orgkind/getOrgKindList.do', param).then((data) => {
        if (data.success == true) {
        
          self.selOrgList = data.body.list
          // self.selOrgList.splice(0, 0, {orgID: '', fullName: '全部'})
        }
      })
    },
     selectChange (type, parentID) { // 下拉框值改变事件  type=1市下拉框的值改变事件   type=2区下拉框的值改变事件
      if (type === 1) {
        // this.selectarea = [{id: '', name: '全部'}]
        if (parentID !== '') {
          this.getList('common/getAreasList.do', { 'parentID': parentID }, 'selectarea')
        }
        this.queryForm.countryID = ''
        // this.selectGarden = [{orgID: '', fullName: '全部'}]
        // this.queryForm.orgID = ''
        // this.getList('orgkind/getOrgKindList.do', {provinceID: this.queryForm.provinceID, cityID: this.queryForm.cityID, countryID: ''}, 'selectGarden', true)
      } else if (type === 2) {
        this.queryForm.fullName=''
        // this.selectGarden = [{orgID: '', fullName: '全部'}]
        // this.queryForm.orgID = ''
        // this.getList('orgkind/getOrgKindList.do', {provinceID: this.queryForm.provinceID, cityID: this.queryForm.cityID, countryID: parentID}, 'selectGarden', true)
      }
      this.getOrg()

    },
    close (flag) {
      this.dialogTableVisible = flag
    },
    pageSizeChange (val) { // 每页显示条数
      this.queryForm.pageSize = val

      this.queryForm.keyWord = this.keyWord

      this.getUsers()
    },
    pageCurrentChange (val) { // 分页
      this.queryForm.pageNum = val
      this.queryForm.keyWord = this.keyWord
      this.getUsers(val)
    },
    // query (param) { // 查询按钮
    //   // this.queryForm.keyWord = this.keyWord
    //   // this.queryForm.pageNum = 1
    //   this.getUsers()
    // },
    getUsers () { // 获取页面列表
      let self = this
      var pram=self.queryForm
      // console.log(self.queryForm)
      api.post(config.host + 'orgkind/getOrgKindList.do', pram).then((data) => {
        if (data.success == true) {
          self.queryForm.keyWord = self.keyWord

          self.tableData = data.body.list

          self.total_rows = data.body.page.total
        }
      })
    },
    orgDel (index, row) { // 详情
      this.dialogTableVisible = true

      this.$router.push({path: '/orgmgr/detail/' + row.orgID })
    },
    changeType () {
      let self = this
      if (self.queryForm.orgFirstType == 1) {
        self.orgSecondType = true
        self.queryForm.orgSecondType = ''

        if (self.isGuizhou == true) {
          self.org = self.orgSguizhou
        } else {
          self.org = self.orgS
        }
      } else if (self.queryForm.orgFirstType == 2) {
        self.org = self.orgSe
        self.orgSecondType = true
        self.queryForm.orgSecondType = ''
      } else {
        self.orgSecondType = false
      }
    },
      getList (url, param, key, isOrg) {
      var that = this
      that[key + ''] = []
      api.post(url, param).then(function (response) {
        that[key + ''] = response.body.list
        // if (isOrg) {
        //   that[key + ''].splice(0, 0, {orgID: '', fullName: '全部'})
        // } else {
        //   that[key + ''].splice(0, 0, {id: '', name: '全部'})
        // }
      })
    },
    doClick(operFunc,index,row){
      switch(operFunc){
       case 'showDetail':this.orgDel(index,row);break
      }
    },
    downloadTestPaper () { // 下载试卷
      // 试卷下载权利检测
      api.post(config.khsHost + 'order/teacher/hasDownloadPower.do', {}).then((data) => {
        if (data.body == true) {
          location.href = config.khsHost + 'order/teacher/downloadTestPaper.do?Haiziguo-Token=' + localStorage.getItem('Haiziguo-Token')
        } else {
          MessageBox.alert('您没有下载权限！');
        }
      })
    }
  },
  created: function () {
    let that=this
        // 创建完毕状态
    this.orgSecondType = false
    this.queryForm.orgSecondType = this.queryForm.orgSecondType + ''

    api.post(config.host + 'orgkind/getOrgKindList.do', { 'pageNum': 1, 'pageSize': 10 }).then((data) => {
      if (data.success == true) {
        this.total = data.body.page.total

        this.tableData = data.body.list
        this.total_rows = data.body.page.total
      }
    })
    api.get(config.host + 'org/getOrgDetail.do').then((json) => {
      if (json.success == true) {
        if (json.body.provinceID == '520000') { // 贵州
          this.isGuizhou = true
        } else {
          this.isGuizhou = false
        }

        if (json.body.scopeType === 1) { // 当前账号是省级妇保院
          that.show.selCity = true
          that.show.selCountry = true
          // that.selectcity = [{id: '', name: '全部'}]
          // that.selectarea = [{id: '', name: '全部'}]
          that.getList('common/getAreasList.do', { 'parentID': json.body.provinceID }, 'selectcity')
          // that.getList('common/getAreasList.do', { 'parentID': json.body.cityID }, 'selectarea')
          // that.getList('orgkind/getOrgKindList.do', {provinceID: json.body.provinceID}, 'selectGarden', true)
        } else if (json.body.scopeType === 2) { // 当前账号是市级妇保院
          that.show.selCountry = true
          // that.selectarea = [{id: '', name: '全部'}]
          that.getList('common/getAreasList.do', { 'parentID': json.body.cityID }, 'selectarea')
          // that.getList('orgkind/getOrgKindList.do', {provinceID: json.body.provinceID, cityID: json.body.cityID}, 'selectGarden', true)
        } else if (json.body.scopeType === 3) { // 当前账号是区级妇保院/街道级妇保
          // that.getList('orgkind/getOrgKindList.do', {provinceID: json.body.provinceID, cityID: json.body.cityID, countryID: json.body.countryID}, 'selectGarden', true)
        } else if (json.body.scopeType === 4) {
          // that.getList('orgkind/getOrgKindList.do', {}, 'selectGarden', true)
        }
      }
    })
    // 试卷下载权利检测
    api.post(config.khsHost + 'order/teacher/hasDownloadPower.do', {}).then((data) => {
      if(data.success) {
        if (data.body == true) {
          that.isDownloadTestPaper = true;
        } else {
          that.isDownloadTestPaper = false;
        }
      }
    })
  },
  mounted: function () {
        // 挂载结束状态
    this.getUsers()
    this.getOrg()
    let btnList = window.paramFromParent
    btnList = common.getBtnList(btnList)
    this.generalArea = btnList.generalArea
    this.listArea = btnList.listArea
  }

}
</script>

<style>
.el-table th{
    background:#F5F5F5 !important;
    font-size:15px;
}
.ibox-content{
    padding: 0px 20px 20px 20px;
    border:none;
}
.general-area{
  margin-bottom:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/orgmgr/orgmgr.vue?4e8986f6